import { Component, OnDestroy, OnInit } from '@angular/core';
import { GradoService } from '../services/grado.service';
import {ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-grado',
  templateUrl: './grado.component.html',
  styleUrls: ['./grado.component.scss']
})
export class GradoComponent implements OnInit, OnDestroy {
	children: any;
	grado = '7';
  gradoSymbol = '';
  routeSubscription: Subscription;
  gradoSubscription: Subscription;
  constructor(private gradoService: GradoService,
    private router: Router,
    private activatedRoute: ActivatedRoute
) {

              }

  ngOnInit() {
    if(!this.routeSubscription){
      this.routeSubscription = this.activatedRoute.params.subscribe( params => {
        if(this.gradoSubscription)this.gradoSubscription.unsubscribe();

        // @param id
        this.grado = params['id'];
        this.gradoSymbol = this.grado.indexOf('K') > -1 ? '' : '°';
        if(!this.gradoSubscription){
          this.gradoService.findGrado(this.grado).subscribe(
            (children) => {
              this.children = children;
          });
        }
      });
    }

  }

  ngOnDestroy() {
    if(this.routeSubscription)this.routeSubscription.unsubscribe();
    if(this.gradoSubscription)this.gradoSubscription.unsubscribe();
  }

}
